export enum MainRoutes {
  LOGIN = 'login',
  HOME = 'inicio'
}

export enum AuthorizationsRoutes {
  AUTHORIZATIONS = 'autorizaciones',
  CREATE = 'crear'
}
